<template>
  <b-button @click="click" :type="nativeType" :variant="variant" :disabled="loading || disabled" class="btn" :size="size" :class="{
    'btn-block': block,
    'btn-loading': loading
  }">
    <slot></slot>
  </b-button>
</template>

<script>
  export default {
    name: 'o-button',

    props: {
      variant: {
        type: String,
        default: 'primary'
      },

      nativeType: {
        type: String,
        default: 'submit'
      },

      loading: {
        type: Boolean,
        default: false
      },

      disabled: {
        type: Boolean,
        default: false
      },

      block: Boolean,

      size: {
        type: String,
        default: 'md'
      }
    },
    methods: {
      click(e) {
        this.$emit('click', e)
      }
    }
  }
</script>
